import { createFileRoute } from '@tanstack/react-router'
import { EmployeeEditor } from './-EmployeeEditor'

export const Route = createFileRoute('/hr/employees/$id')({
  component: EmployeeDetailPage,
})

function EmployeeDetailPage() {
  const { id } = Route.useParams()
  return <EmployeeEditor id={id} />
}
